import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeValueWriteRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeValue } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type CreateAttributeValueVariables = {
    typeId: string;
    body: AttributeValueWriteRequest;
};

export const useCreateAttributeValueMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeValue>,
        Error,
        CreateAttributeValueVariables
    >({
        mutationFn: ({ typeId, body }) =>
            apiClient.attributeTypes.createValue(typeId, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
